import React from "react"

interface BadgeProps {
  children: React.ReactNode
  variant?: "red" | "green" | "blue" | "orange" | "yellow" | "purple" | "gray"
  icon?: React.ReactNode
  className?: string
}

const Badge: React.FC<BadgeProps> = ({
  children,
  variant = "gray",
  icon,
  className = "",
}) => {
  const variantStyles = {
    red: "border-red-200 bg-red-50 text-red-700",
    green: "border-green-200 bg-green-50 text-green-700",
    blue: "border-blue-200 bg-blue-50 text-blue-700",
    orange: "border-orange-200 bg-orange-50 text-orange-700",
    yellow: "border-yellow-200 bg-yellow-50 text-yellow-700",
    purple: "border-purple-200 bg-purple-50 text-purple-700",
    gray: "border-gray-200 bg-gray-50 text-gray-700",
  }

  return (
    <span
      className={`inline-flex items-center gap-1 rounded border px-1.5 py-0.5 text-xs ${variantStyles[variant]} ${className}`}
    >
      {icon && icon}
      {children}
    </span>
  )
}

export default Badge
